import React from "react";
import {
  Alert,
  Button,
  Grid,
  Input,
  SpaceBetween,
} from "@amzn/awsui-components-console";
import { useNavigate } from "react-router-dom";
import { URLS } from "src/components/constants/appConstants";
import { FullPageTitle } from "src/components/header/title";
import { inputValidation } from "src/commons/input-validation";

interface Props {
  keyword: string;
  setValue: Function;
  error?: string;
}

const GetPlan = ({ keyword, setValue, error }: Props) => {
  const navigate = useNavigate();
  const onClick = () => {
    if (!inputValidation(keyword)) {
      // Navigating updates the URL id, which remounts the page component and
      // triggers the auto-search in componentDidMount. Relying on that avoids
      // firing a duplicate search on the unmounting instance.
      navigate(`${URLS.LINK_ARD_TO_A_PLAN}/${keyword}`);
    }
  };
  return (
    <>
      <FullPageTitle
        title={"Re-Mapping ARD to Plan"}
        description={"Re-Maps the ARD of a Fuse Plan"}
      />
      <div className="page">
        <SpaceBetween size="l">
          <div style={{ paddingLeft: "10px" }}>
            <div className="input-container">
              <div className="input-filter">
                <Input
                  data-testid="input-filter"
                  type="search"
                  value={keyword}
                  onChange={(e: any) => {
                    if (e.detail != null) {
                      const trimmedValue = e.detail.value.trim();
                      setValue(trimmedValue);
                    }
                  }}
                  placeholder="Please enter planId"
                  clearAriaLabel="clear"
                  ariaDescribedby={""}
                />
              </div>
              <Button onClick={onClick}>Get Plan</Button>
            </div>
          </div>
          {error ? (
            <div className="alert-box">
              <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
                <Alert header={error} type="error"></Alert>
              </Grid>
            </div>
          ) : null}
        </SpaceBetween>
      </div>
    </>
  );
};
export default GetPlan;
